<template>
  <div class="cssrs-epic">
    <div style="width: 100%">
      <div v-for="(rows, customRowIndex) in activityQuestions" :key="customRowIndex">
        <div v-if="customRowIndex === 0">
          <SinceLastVisitInto :instructionScreen="rows[0]" :lang="lang" />
        </div>
        <div row v-if="customRowIndex === 1" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-column border border-bottom-0 border-black">
          <div class="col-row pl-15 border-bottom border-black bg-light">
            <span
              v-translate:_formattedTitle="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedTitle
              }"
              v-html="rows[0].formattedTitle"
            ></span>
          </div>
          <div class="col-row border-bottom border-black">
            <b-col md="10" class="border-right border-black col-size-7">
              <span
                v-translate:_formattedInformation="{
                  key: rows[0].id,
                  val: lang,
                  html: rows[0].formattedInformation
                }"
                v-html="rows[0].formattedInformation"
              ></span>
            </b-col>
            <b-col
              md="2"
              class="border-right border-black col-size-3 p-0"
              v-translate:_sinceLast="{
                key: rows[0].id,
                val: lang,
                html: sinceLastVisitInstruction
              }"
            >
              <p class="table-heading"><span class="d-block">Since Last</span> Visit</p>
            </b-col>
          </div>
        </div>
        <div row v-if="customRowIndex === 2" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-column border border-top-0 border-bottom-0 border-black">
          <div class="col-row">
            <b-col md="10" class="border-right border-black col-size-7">
              <div
                v-translate:_formattedBody="{
                  key: rows[1].id,
                  val: lang,
                  html: rows[1].formattedBody
                }"
                v-html="rows[1].formattedBody"
              ></div>
              <div v-if="rows[0]" class="d-flex align-items-center">
                <span
                  class="text-nowrap"
                  v-translate:_formattedBody="{
                    key: rows[0].id,
                    val: lang,
                    html: rows[0].formattedBody
                  }"
                  v-html="rows[0].formattedBody"
                ></span>
                <b-form-textarea class="mb-0 ml-5 mr-15 activity-Form-Text" type="text" name="activityFormTextPreview" v-model="rows[0].answer" @input="onAnswerChange(rows[0])" rows="6" :class="{ 'is-danger': rows[0].hasFieldError }" maxlength="500" />
              </div>
            </b-col>

            <b-col md="2" class="border-right border-black pt-25 pb-25 pl-40 pr-40 col-md-2 col-size-3">
              <div class="d-flex justify-content-between">
                <div class="yes">
                  <label
                    v-translate:_yes="{
                      key: 'rsb',
                      val: lang,
                      html: rows[1].options[0].formattedBody
                    }"
                    v-html="rows[1].options[0].formattedBody"
                    class="d-block checkbox-label"
                  ></label>
                  <input type="checkbox" class="radio" :value="rows[1].options[0].id" name="fooby[08][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick(rows[1], $event)" :checked="rows[1].answerId === rows[1].options[0].id" />
                </div>
                <div class="no">
                  <label
                    v-translate:_no="{
                      key: 'rsb',
                      val: lang,
                      html: rows[1].options[1].formattedBody
                    }"
                    class="d-block checkbox-label"
                    v-html="rows[1].options[1].formattedBody"
                  ></label>
                  <input type="checkbox" class="radio" name="fooby[08][]" :value="rows[1].options[1].id" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick(rows[1], $event)" :checked="rows[1].answerId === rows[1].options[1].id" />
                </div>
              </div>
            </b-col>
          </div>
        </div>

        <div row v-if="customRowIndex === 3" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border border-bottom-0 border-black">
          <b-col md="10" class="border-right border-black col-size-7">
            <div
              v-translate:_formattedBody="{
                key: rows[1].id,
                val: lang,
                html: rows[1].formattedBody
              }"
              v-html="rows[1].formattedBody"
            ></div>
            <div v-if="rows[0]" class="d-flex align-items-center">
              <span
                class="text-nowrap"
                v-translate:_formattedBody="{
                  key: rows[0].id,
                  val: lang,
                  html: rows[0].formattedBody
                }"
                v-html="rows[0].formattedBody"
              ></span>
              <b-form-textarea class="mb-0 ml-5 mr-15 activity-Form-Text" type="text" name="activityFormTextPreview" v-model="rows[0].answer" @input="onAnswerChange(rows[0])" rows="6" :class="{ 'is-danger': rows[0].hasFieldError }" maxlength="500" />
            </div>
          </b-col>

          <b-col md="2" class="border-right border-black pt-25 pb-25 pl-40 pr-40 col-md-2 col-size-3">
            <div class="d-flex justify-content-between">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[0].formattedBody
                  }"
                  v-html="rows[1].options[0].formattedBody"
                  class="d-block checkbox-label"
                ></label>
                <input type="checkbox" class="radio" :value="rows[1].options[0].id" name="fooby[09][]" @input="OnBooleanValueChange(rows[1], $event)" v-on:click="onCheckboxClick(rows[1], $event)" :checked="rows[1].answerId === rows[1].options[0].id" />
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" name="fooby[09][]" :value="rows[1].options[1].id" @input="OnBooleanValueChange(rows[1], $event)" v-on:click="onCheckboxClick(rows[1], $event)" :checked="rows[1].answerId === rows[1].options[1].id" />
              </div>
            </div>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 4" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border border-bottom-0 border-black" :class="{ disabled: isSuicidalIdeation }">
          <b-col md="10" class="border-right border-black col-size-7">
            <div
              v-translate:_formattedBody="{
                key: rows[1].id,
                val: lang,
                html: rows[1].formattedBody
              }"
              v-html="rows[1].formattedBody"
            ></div>
            <div v-if="rows[0]" class="d-flex align-items-center">
              <span
                class="text-nowrap"
                v-translate:_formattedBody="{
                  key: rows[0].id,
                  val: lang,
                  html: rows[0].formattedBody
                }"
                v-html="rows[0].formattedBody"
              ></span>
              <b-form-textarea class="mb-0 ml-5 mr-15 activity-Form-Text" type="text" name="activityFormTextPreview" v-model="rows[0].answer" @input="onAnswerChange(rows[0])" rows="6" :class="{ 'is-danger': rows[0].hasFieldError }" maxlength="500" />
            </div>
          </b-col>

          <b-col md="2" class="border-right border-black pt-25 pb-25 pl-40 pr-40 col-md-2 col-size-3">
            <div class="d-flex justify-content-between">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[0].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[1].options[0].id" name="fooby[3][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick(rows[1], $event)" :checked="rows[1].answerId === rows[1].options[0].id" :disabled="isSuicidalIdeation" />
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" name="fooby[3][]" :value="rows[1].options[1].id" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick(rows[1], $event)" :checked="rows[1].answerId === rows[1].options[1].id" :disabled="isSuicidalIdeation" />
              </div>
            </div>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 5" :class="{ disabled: isSuicidalIdeation }" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border border-bottom-0 border-black">
          <b-col md="10" class="border-right border-black col-size-7">
            <div
              v-translate:_formattedBody="{
                key: rows[1].id,
                val: lang,
                html: rows[1].formattedBody
              }"
              v-html="rows[1].formattedBody"
            ></div>
            <div v-if="rows[0]" class="d-flex align-items-center">
              <span
                class="text-nowrap"
                v-translate:_formattedBody="{
                  key: rows[0].id,
                  val: lang,
                  html: rows[0].formattedBody
                }"
                v-html="rows[0].formattedBody"
              ></span>
              <b-form-textarea class="mb-0 ml-5 mr-15 activity-Form-Text" type="text" name="activityFormTextPreview" v-model="rows[0].answer" @input="onAnswerChange(rows[0])" rows="6" :class="{ 'is-danger': rows[0].hasFieldError }" maxlength="500" />
            </div>
          </b-col>

          <b-col md="2" class="border-right border-black pt-25 pb-25 pl-40 pr-40 col-md-2 col-size-3">
            <div class="d-flex justify-content-between">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[0].formattedBody"
                ></label>
                <input :disabled="isSuicidalIdeation" type="checkbox" class="radio" :value="rows[1].options[0].id" name="fooby[4][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick(rows[1], $event)" :checked="rows[1].answerId === rows[1].options[0].id" />
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[1].formattedBody"
                ></label>
                <input :disabled="isSuicidalIdeation" type="checkbox" class="radio" name="fooby[4][]" :value="rows[1].options[1].id" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick(rows[1], $event)" :checked="rows[1].answerId === rows[1].options[1].id" />
              </div>
            </div>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 6" :class="{ disabled: isSuicidalIdeation }" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border border-bottom-0 border-black">
          <b-col md="10" class="border-right border-black col-size-7">
            <div
              v-translate:_formattedBody="{
                key: rows[1].id,
                val: lang,
                html: rows[1].formattedBody
              }"
              v-html="rows[1].formattedBody"
            ></div>
            <div v-if="rows[0]" class="d-flex align-items-center">
              <span
                class="text-nowrap"
                v-translate:_formattedBody="{
                  key: rows[0].id,
                  val: lang,
                  html: rows[0].formattedBody
                }"
                v-html="rows[0].formattedBody"
              ></span>
              <b-form-textarea class="mb-0 ml-5 mr-15 activity-Form-Text" type="text" name="activityFormTextPreview" v-model="rows[0].answer" @input="onAnswerChange(rows[0])" rows="6" :class="{ 'is-danger': rows[0].hasFieldError }" maxlength="500" />
            </div>
          </b-col>

          <b-col md="2" class="border-right border-black pt-25 pb-25 pl-40 pr-40 col-md-2 col-size-3">
            <div class="d-flex justify-content-between">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[0].formattedBody"
                ></label>
                <input type="checkbox" :disabled="isSuicidalIdeation" class="radio" :value="rows[1].options[0].id" name="fooby[5][]" @input="OnBooleanValueChange(rows[1], $event)" v-on:click="onCheckboxClick(rows[1], $event)" :checked="rows[1].answerId === rows[1].options[0].id" />
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[1].formattedBody"
                ></label>
                <input type="checkbox" :disabled="isSuicidalIdeation" class="radio" name="fooby[5][]" :value="rows[1].options[1].id" @input="OnBooleanValueChange(rows[1], $event)" v-on:click="onCheckboxClick(rows[1], $event)" :checked="rows[1].answerId === rows[1].options[1].id" />
              </div>
            </div>
          </b-col>
        </div>
        <div row v-if="customRowIndex === 7" :class="{ disabled: intensityOfIdeationSection }" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-column border border-bottom-0 border-black">
          <div
            class="pl-10 border-black bg-light border-bottom"
            v-translate:_formattedTitle="{
              key: rows[0].id,
              val: lang,
              html: rows[0].formattedTitle
            }"
            v-html="rows[0].formattedTitle"
          ></div>
          <b-col
            md="10"
            class="border-right border-black col-size-7"
            v-translate:_formattedInformation="{
              key: rows[0].id,
              val: lang,
              html: rows[0].formattedInformation
            }"
            v-html="rows[0].formattedInformation"
          >
          </b-col>
          <b-col md="2" class="border-right border-black col-size-3"> </b-col>
        </div>
        <div row v-if="customRowIndex === 8" :class="{ disabled: intensityOfIdeationSection }" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex border-top-0 flex-column border border-bottom-0 border-black">
          <div class="col-row">
            <b-col md="10" class="border-right border-black col-size-7">
              <div class="col-sm alignleft th-ssrc-number-input pl-0">
                <span
                  v-translate:_formattedBody="{
                    key: rows[0].id,
                    val: lang,
                    html: rows[0].formattedBody
                  }"
                  v-html="rows[0].formattedBody"
                ></span>
                <div class="pl-50" style="line-height: 4px">
                  <span class="ml-10 text-center span_box qu-text-normal">
                    {{ rows[0].answer }}
                    <input type="text" placeholder=" " class="ml-10 input_box" disabled="" />
                  </span>
                  <div
                    class="question-heading-Italic pt-10 pb-10 border-top"
                    v-translate:_type="{
                      key: rows[0].id,
                      val: lang,
                      html: 'Type # (1-5)'
                    }"
                  >
                    <span> Type # (1-5) </span>
                  </div>
                </div>
                <div class="sscr-most-severe-text-res" style="width: 50%; margin-left: 4rem">
                  <span class="pl-7 qu-text-normal">
                    {{ rows[1].answer }}
                  </span>
                  <input type="text" placeholder=" " class="ml-10 input_box" disabled="" />
                  <span
                    v-translate:_formattedBody="{
                      key: rows[1].id,
                      val: lang,
                      html: rows[1].formattedBody
                    }"
                    v-html="rows[1].formattedBody"
                  ></span>
                </div>
              </div>
            </b-col>
            <b-col md="2" class="border-right border-black pt-0 pb-10 qu-text-normal text-center fs-16 col-size-3 most-severe-center">
              <span
                class="pt-30 m-0"
                v-translate:_mostSevere="{
                  key: activityQuestions[7][0].id,
                  val: lang,
                  html: mostSeverLabel
                }"
              >
                Most <span class="d-block">Severe</span></span
              >
            </b-col>
          </div>
        </div>

        <div row v-if="customRowIndex === 9" :class="{ disabled: intensityOfIdeationSection }" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border border-bottom-0 border-black">
          <b-col md="10" class="border-right border-black col-size-7">
            <div
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></div>
          </b-col>

          <b-col md="2" class="border-right border-black pt-25 pb-10 d-flex justify-content-center col-md-2 col-size-3">
            <select v-model="rows[0].answer" size="sm" class="form-control input-md custom-number-select-box" @change="onFieldChange(rows[0])" :disabled="intensityOfIdeationSection">
              <option key value>&nbsp;</option>
              <option v-for="choice in rows[0].options" :key="choice.id" :value="choice.body">
                {{ choice.formattedBody }}
              </option>
            </select>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 10" :class="{ disabled: intensityOfIdeationSection }" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border border-bottom-0 border-black">
          <b-col md="10" class="border-right border-black col-size-7">
            <div
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></div>
          </b-col>

          <b-col md="2" class="border-right border-black pt-40 pb-25 d-flex justify-content-center col-md-2 col-size-3">
            <select v-model="rows[0].answer" size="sm" class="form-control input-md custom-number-select-box" @change="onFieldChange(rows[0])" :disabled="intensityOfIdeationSection">
              <option key value>&nbsp;</option>
              <option v-for="choice in rows[0].options" :key="choice.id" :value="choice.body">
                {{ choice.formattedBody }}
              </option>
            </select>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 11" :class="{ disabled: intensityOfIdeationSection }" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border border-bottom-0 border-black">
          <b-col md="10" class="border-right border-black col-size-7">
            <div
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></div>
          </b-col>

          <b-col md="2" class="border-right border-black pt-40 pb-40 d-flex justify-content-center col-md-2 col-size-3">
            <select v-model="rows[0].answer" size="sm" class="form-control input-md custom-number-select-box" @change="onFieldChange(rows[0])" :disabled="intensityOfIdeationSection">
              <option key value>&nbsp;</option>
              <option v-for="choice in rows[0].options" :key="choice.id" :value="choice.body">
                {{ choice.formattedBody }}
              </option>
            </select>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 12" :class="{ disabled: intensityOfIdeationSection }" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border border-bottom-0 border-black">
          <b-col md="10" class="border-right border-black col-size-7">
            <div
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></div>
          </b-col>

          <b-col md="2" class="border-right border-black pt-40 pb-40 d-flex justify-content-center col-md-2 col-size-3">
            <select v-model="rows[0].answer" size="sm" class="form-control input-md custom-number-select-box" @change="onFieldChange(rows[0])" :disabled="intensityOfIdeationSection">
              <option key value>&nbsp;</option>
              <option v-for="choice in rows[0].options" :key="choice.id" :value="choice.body">
                {{ choice.formattedBody }}
              </option>
            </select>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 13" :class="{ disabled: intensityOfIdeationSection }" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border border-bottom-0 border-black">
          <b-col md="10" class="border-right border-black col-size-7">
            <div
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></div>
          </b-col>

          <b-col md="2" class="border-right border-black pt-90 pb-70 d-flex justify-content-center col-md-2 col-size-3">
            <select v-model="rows[0].answer" size="sm" class="form-control input-md custom-number-select-box" @change="onFieldChange(rows[0])" :disabled="intensityOfIdeationSection">
              <option key value>&nbsp;</option>
              <option v-for="choice in rows[0].options" :key="choice.id" :value="choice.body">
                {{ choice.formattedBody }}
              </option>
            </select>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 14" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-column border border-bottom-0 border-black">
          <div class="border-black bg-light" style="display: flex">
            <b-col md="10" class="border-right border-black pb-10 col-size-7">
              <span
                v-translate:_formattedTitle="{
                  key: rows[0].id,
                  val: lang,
                  html: rows[0].formattedTitle
                }"
                v-html="rows[0].formattedTitle"
              ></span>
              <span
                v-translate:_formattedInformation="{
                  key: rows[0].id,
                  val: lang,
                  html: rows[0].formattedInformation
                }"
                v-html="rows[0].formattedInformation"
              ></span>
            </b-col>
            <b-col
              md="2"
              class="border-right border-black col-size-3"
              v-translate:_sinceLast="{
                key: rows[0].id,
                val: lang,
                html: suicidalBehaviorInstruction
              }"
            >
              <p class="table-heading m-0"><span class="d-block">Since</span> Last Visit</p>
            </b-col>
          </div>
        </div>

        <div row v-if="customRowIndex === 15" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-column border border-bottom-0 border-black">
          <div class="col-row">
            <b-col md="10" class="border-right border-black col-size-7">
              <div>
                <span
                  v-translate:_formattedBody="{
                    key: rows[0].id,
                    val: lang,
                    html: rows[0].formattedBody
                  }"
                  v-html="rows[0].formattedBody"
                ></span>
              </div>
            </b-col>
            <b-col md="2" class="border-right border-black pt-25 pb-25 p-0 col-md-2 col-size-3">
              <div class="d-flex justify-content-between pl-40 pr-40">
                <div class="yes">
                  <label
                    v-translate:_yes="{
                      key: 'rsb',
                      val: lang,
                      html: rows[0].options[0].formattedBody
                    }"
                    class="d-block checkbox-label"
                    v-html="rows[0].options[0].formattedBody"
                  ></label>
                  <input type="checkbox" class="radio" :value="rows[0].options[0].id" name="fooby[11][]" @input="OnBooleanValueChange(rows[0], $event)" @click="onCheckboxClick" :checked="rows[0].answerId === rows[0].options[0].id" />
                </div>
                <div class="no">
                  <label
                    v-translate:_no="{
                      key: 'rsb',
                      val: lang,
                      html: rows[0].options[1].formattedBody
                    }"
                    class="d-block checkbox-label"
                    v-html="rows[0].options[1].formattedBody"
                  ></label>
                  <input type="checkbox" class="radio" :value="rows[0].options[1].id" name="fooby[11][]" @input="OnBooleanValueChange(rows[0], $event)" @click="onCheckboxClick" :checked="rows[0].answerId === rows[0].options[1].id" />
                </div>
              </div>
              <div style="padding-top: 7rem" :class="{ disabled: issuicidalBehaviorSection }">
                <span
                  v-translate:_formattedBody="{
                    key: rows[2].id,
                    val: lang,
                    html: rows[2].formattedBody
                  }"
                  v-html="rows[2].formattedBody"
                ></span>
                <div class="th-ssrc-number-input pl-30 pr-30">
                  <input type="number" :disabled="issuicidalBehaviorSection" @input="onNumberValueChange(rows[2], $event)" v-model="rows[2].answer" class="" placeholder=" " />
                </div>
              </div>
            </b-col>
          </div>
          <div class="col-row">
            <b-col md="10" class="border-right border-black col-size-7">
              <div class="align-items-center d-flex" :class="{ disabled: issuicidalBehaviorSection }">
                <p
                  class="qu-text-normal text-nowrap"
                  v-translate:_formattedBody="{
                    key: rows[1].id,
                    val: lang,
                    html: rows[1].formattedBody
                  }"
                  v-html="rows[1].formattedBody"
                ></p>
                <b-form-textarea class="mb-0 ml-5 mr-15 activity-Form-Text" type="text" name="activityFormTextPreview" rows="6" v-model="rows[1].answer" @input="onAnswerChange(rows[1])" :disabled="issuicidalBehaviorSection" :class="{ 'is-danger': rows[1].hasFieldError }" maxlength="500" />
              </div>
            </b-col>
          </div>

          <div class="col-row">
            <b-col md="10" class="border-right border-black col-size-7 d-flex align-items-end">
              <span
                v-translate:_formattedBody="{
                  key: rows[3].id,
                  val: lang,
                  html: rows[3].formattedBody
                }"
                v-html="rows[3].formattedBody"
              ></span>
            </b-col>
            <b-col md="2" class="border-right border-black pt-25 pl-40 pr-40 col-md-2 col-size-3">
              <div class="d-flex justify-content-between">
                <div class="yes">
                  <label
                    v-translate:_yes="{
                      key: 'rsb',
                      val: lang,
                      html: rows[3].options[0].formattedBody
                    }"
                    class="d-block checkbox-label"
                    v-html="rows[3].options[0].formattedBody"
                  ></label>
                  <input type="checkbox" class="radio" :value="rows[3].options[0].id" name="fooby[011][]" @input="OnBooleanValueChange(rows[3], $event)" @click="onCheckboxClick" :checked="rows[3].answerId === rows[3].options[0].id" />
                </div>
                <div class="no">
                  <label
                    v-translate:_no="{
                      key: 'rsb',
                      val: lang,
                      html: rows[3].options[1].formattedBody
                    }"
                    class="d-block checkbox-label"
                    v-html="rows[3].options[1].formattedBody"
                  ></label>
                  <input type="checkbox" class="radio" :value="rows[3].options[1].id" name="fooby[011][]" @input="OnBooleanValueChange(rows[3], $event)" @click="onCheckboxClick" :checked="rows[3].answerId === rows[3].options[1].id" />
                </div>
              </div>
            </b-col>
          </div>
        </div>

        <div row v-if="customRowIndex === 16" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex border-bottom-0 flex-column border border-black">
          <div class="col-row">
            <b-col md="10" class="border-right border-black col-size-7">
              <div
                v-translate:_formattedBody="{
                  key: rows[0].id,
                  val: lang,
                  html: rows[0].formattedBody
                }"
                v-html="rows[0].formattedBody"
              ></div>
            </b-col>
            <b-col md="2" class="border-right border-black pt-25 pb-25 pl-40 pr-40 col-md-2 col-size-3">
              <div class="d-flex justify-content-between">
                <div class="yes">
                  <label
                    v-translate:_yes="{
                      key: 'rsb',
                      val: lang,
                      html: rows[0].options[0].formattedBody
                    }"
                    class="d-block checkbox-label"
                    v-html="rows[0].options[0].formattedBody"
                  ></label>
                  <input type="checkbox" class="radio" :value="rows[0].options[0].id" name="fooby[15][]" @input="OnBooleanValueChange(rows[0], $event)" @click="onCheckboxClick" :checked="rows[0].answerId === rows[0].options[0].id" />
                </div>
                <div class="no">
                  <label
                    v-translate:_no="{
                      key: 'rsb',
                      val: lang,
                      html: rows[0].options[1].formattedBody
                    }"
                    class="d-block checkbox-label"
                    v-html="rows[0].options[1].formattedBody"
                  ></label>
                  <input type="checkbox" class="radio" :value="rows[0].options[1].id" name="fooby[15][]" @input="OnBooleanValueChange(rows[0], $event)" @click="onCheckboxClick" :checked="rows[0].answerId === rows[0].options[1].id" />
                </div>
              </div>
            </b-col>
          </div>
          <div class="col-row">
            <b-col md="10" class="border-right border-black col-size-7" :class="{ disabled: isInterruptedAttempt }">
              <div class="align-items-center d-flex">
                <p
                  class="qu-text-normal text-nowrap"
                  v-translate:_formattedBody="{
                    key: rows[1].id,
                    val: lang,
                    html: rows[1].formattedBody
                  }"
                  v-html="rows[1].formattedBody"
                ></p>
                <b-form-textarea class="mb-0 ml-5 mr-15 activity-Form-Text" type="text" name="activityFormTextPreview" rows="6" v-model="rows[1].answer" @input="onAnswerChange(rows[1])" :disabled="isInterruptedAttempt" maxlength="500" />
              </div>
            </b-col>
            <b-col md="2" class="border-right border-black pb-10 p-0 col-size-3 text-center" :class="{ disabled: isInterruptedAttempt }">
              <span
                v-translate:_formattedBody="{
                  key: rows[2].id,
                  val: lang,
                  html: rows[2].formattedBody
                }"
                v-html="rows[2].formattedBody"
              ></span>
              <div class="th-ssrc-number-input pl-30 pr-30">
                <input :disabled="isInterruptedAttempt" type="number" v-model="rows[2].answer" @input="onNumberValueChange(rows[2], $event)" class="" placeholder=" " />
              </div>
            </b-col>
          </div>
        </div>

        <div row v-if="customRowIndex === 17" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex border-bottom-0 flex-column border border-black">
          <div class="col-row">
            <b-col md="10" class="border-right border-black col-size-7">
              <div
                v-translate:_formattedBody="{
                  key: rows[0].id,
                  val: lang,
                  html: rows[0].formattedBody
                }"
                v-html="rows[0].formattedBody"
              ></div>
            </b-col>
            <b-col md="2" class="border-right border-black pt-25 pb-0 pl-40 pr-40 col-md-2 col-size-3">
              <div class="d-flex justify-content-between">
                <div class="yes">
                  <label
                    v-translate:_yes="{
                      key: 'rsb',
                      val: lang,
                      html: rows[0].options[0].formattedBody
                    }"
                    class="d-block checkbox-label"
                    v-html="rows[0].options[0].formattedBody"
                  ></label>
                  <input type="checkbox" class="radio" :value="rows[0].options[0].id" name="fooby[02][]" @input="OnBooleanValueChange(rows[0], $event)" @click="onCheckboxClick" :checked="rows[0].answerId === rows[0].options[0].id" />
                </div>
                <div class="no">
                  <label
                    v-translate:_no="{
                      key: 'rsb',
                      val: lang,
                      html: rows[0].options[1].formattedBody
                    }"
                    class="d-block checkbox-label"
                    v-html="rows[0].options[1].formattedBody"
                  ></label>
                  <input type="checkbox" class="radio" :value="rows[0].options[1].id" name="fooby[02][]" @input="OnBooleanValueChange(rows[0], $event)" @click="onCheckboxClick" :checked="rows[0].answerId === rows[0].options[1].id" />
                </div>
              </div>
            </b-col>
          </div>
          <div class="col-row">
            <b-col md="10" class="border-right border-black col-size-7" :class="{ disabled: isAbortedAttempt }">
              <div class="align-items-center d-flex">
                <p
                  class="qu-text-normal text-nowrap"
                  v-translate:_formattedBody="{
                    key: rows[1].id,
                    val: lang,
                    html: rows[1].formattedBody
                  }"
                  v-html="rows[1].formattedBody"
                ></p>
                <b-form-textarea class="mb-0 ml-5 mr-15 activity-Form-Text" type="text" name="activityFormTextPreview" rows="6" v-model="rows[1].answer" @input="onAnswerChange(rows[1])" :disabled="isAbortedAttempt" maxlength="500" />
              </div>
            </b-col>
            <b-col md="2" class="border-right border-black pb-10 p-0 col-size-3 text-center" :class="{ disabled: isAbortedAttempt }">
              <span
                v-translate:_formattedBody="{
                  key: rows[2].id,
                  val: lang,
                  html: rows[2].formattedBody
                }"
                v-html="rows[2].formattedBody"
              ></span>
              <div class="th-ssrc-number-input pl-30 pr-30">
                <input :disabled="isAbortedAttempt" type="number" v-model="rows[2].answer" @input="onNumberValueChange(rows[2], $event)" class="" placeholder=" " />
              </div>
            </b-col>
          </div>
        </div>

        <div row v-if="customRowIndex === 18" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border border-bottom-0 border-black">
          <b-col md="10" class="border-right border-black col-size-7">
            <div
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></div>
            <div v-if="rows[1]" class="d-flex align-items-center">
              <span
                class="text-nowrap"
                :class="{ disabled: isPreparatoryActs }"
                v-translate:_formattedBody="{
                  key: rows[1].id,
                  val: lang,
                  html: rows[1].formattedBody
                }"
                v-html="rows[1].formattedBody"
              ></span>
              <b-form-textarea class="mb-0 ml-5 mr-15 activity-Form-Text" type="text" name="activityFormTextPreview" v-model="rows[1].answer" @input="onAnswerChange(rows[1])" rows="6" :disabled="isPreparatoryActs" maxlength="500" />
            </div>
          </b-col>

          <b-col md="2" class="border-right border-black pt-25 pb-0 pl-40 pr-40 col-md-2 col-size-3">
            <div class="d-flex justify-content-between">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[0].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[0].options[0].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[0].options[0].id" name="fooby[001][]" @input="OnBooleanValueChange(rows[0], $event)" v-on:click="onCheckboxClick(rows[0], $event)" :checked="rows[0].answerId === rows[0].options[0].id" />
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[0].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[0].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" name="fooby[001][]" :value="rows[0].options[1].id" @input="OnBooleanValueChange(rows[0], $event)" v-on:click="onCheckboxClick(rows[0], $event)" :checked="rows[0].answerId === rows[0].options[1].id" />
              </div>
            </div>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 19" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border border-bottom-0 border-black">
          <b-col md="10" class="border-right border-black col-size-7">
            <div
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></div>
          </b-col>

          <b-col md="2" class="border-right border-black pt-0 pb-0 pl-40 pr-40 col-md-2 col-size-3">
            <div class="d-flex justify-content-between">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[0].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[0].options[0].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[0].options[0].id" name="fooby[06][]" @input="OnBooleanValueChange(rows[0], $event)" v-on:click="onCheckboxClick(rows[0], $event)" :checked="rows[0].answerId === rows[0].options[0].id" />
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[0].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[0].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" name="fooby[06][]" :value="rows[0].options[1].id" @input="OnBooleanValueChange(rows[0], $event)" v-on:click="onCheckboxClick(rows[0], $event)" :checked="rows[0].answerId === rows[0].options[1].id" />
              </div>
            </div>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 20" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border border-bottom-0 border-black">
          <b-col md="10" class="border-right border-black col-size-7">
            <div
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></div>
          </b-col>

          <b-col md="2" class="border-right border-black pt-0 pb-0 pl-40 pr-40 col-md-2 col-size-3">
            <div class="d-flex justify-content-between">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[0].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[0].options[0].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[0].options[0].id" name="fooby[006][]" @input="OnBooleanValueChange(rows[0], $event)" v-on:click="onCheckboxClick(rows[0], $event)" :checked="rows[0].answerId === rows[0].options[0].id" />
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[0].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[0].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" name="fooby[006][]" :value="rows[0].options[1].id" @input="OnBooleanValueChange(rows[0], $event)" v-on:click="onCheckboxClick(rows[0], $event)" :checked="rows[0].answerId === rows[0].options[1].id" />
              </div>
            </div>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 21" :class="{ disabled: issuicidalBehaviorSection }" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border border-bottom-0 border-black bg-light text-line-height">
          <b-col md="10" class="border-right text-dark border-black col-size-7">
            <span
              v-translate:_formattedInformation="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedInformation
              }"
              v-html="rows[0].formattedInformation"
            >
            </span>
          </b-col>

          <b-col md="2" class="border-right border-black pt-0 pb-0 pl-5 pr-5 col-md-2 col-size-3">
            <span
              v-translate:_formattedBody="{
                key: rows[1].id,
                val: lang,
                html: rows[1].formattedBody
              }"
              v-html="rows[1].formattedBody"
              class="most-leathal date-text-wrap"
            ></span>
            <div class="cssr-baseline-select-date pt-2">
              <span
                class="most-leathal"
                v-translate:_date="{
                  key: rows[1].id,
                  val: lang,
                  html: 'Date:'
                }"
                >Date:</span
              >
              <datepicker input-class="inner-card-date-value pt-2 pb-2 p-0" placeholder=" " v-model="rows[1].date" @input="onAnswerChange(rows[1])" format="dd/MMM/yyyy" name="startDate" :disabled="issuicidalBehaviorSection" :disabled-dates="disabledDates" :key="`${rows[1].id} + a`"></datepicker>
            </div>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 22" :class="{ disabled: issuicidalBehaviorSection }" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border border-bottom-0 border-black">
          <b-col md="10" class="border-right border-black col-size-7">
            <div
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></div>
          </b-col>

          <b-col md="2" class="border-right border-black pb-25 p-0 col-md-2 text-center col-size-3">
            <span
              v-translate:_code="{
                key: 'enter',
                val: lang,
                html: enterCodeLabel
              }"
              class="instruction"
              v-html="enterCodeLabel"
            ></span>
            <span class="d-flex justify-content-center">
              <select v-model="rows[0].answer" size="sm" class="form-control input-md select-size custom-number-select-box pt-70" @change="onFieldChange(rows[0])" :disabled="issuicidalBehaviorSection">
                <option key value>&nbsp;</option>
                <option v-for="choice in rows[0].options" :key="choice.id" :value="choice.body">
                  {{ choice.formattedBody }}
                </option>
              </select>
            </span>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 23" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border border-black">
          <b-col md="10" class="border-right border-black col-size-7">
            <div
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></div>
          </b-col>

          <b-col md="2" class="border-right border-black pb-25 p-0 col-md-2 text-center col-size-3">
            <span
              v-translate:_code="{
                key: 'enter',
                val: lang,
                html: enterCodeLabel
              }"
              class="instruction"
              v-html="enterCodeLabel"
            ></span>
            <span class="d-flex justify-content-center">
              <select v-model="rows[0].answer" size="sm" class="form-control input-md select-size custom-number-select-box pt-70" @change="onFieldChange(rows[0])" :disabled="issuicidalBehaviorSection || isPotentialLethality">
                <option key value>&nbsp;</option>
                <option v-for="choice in rows[0].options" :key="choice.id" :value="choice.body">
                  {{ choice.formattedBody }}
                </option>
              </select>
            </span>
          </b-col>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sinceLastVisit from "./sinceLastVisit.json";
import * as clinRoService from "@/components/services/custom-clinro-branching";
import "@/components/activity-form/activity-form-custom-clinro/sccr.scss";
import SinceLastVisitInto from "./since-last-visit-history.vue";
import Datepicker from "vuejs-datepicker";
import $ from "jquery";
const { WISH_TO_BE_DEAD_SINCE_LAST_VISIT, NON_SPECIFIC_ACTIVE_SLV, SLV_ACTIVE_SUICIDAL_NO_PLAN, SLV_INTENT_TO_ACT, SLV_ACTIVE_SUICIDAL_SPECIFIC_PLAN, ACTUAL_ATTEMPT_SLV, SLV_ACTUAL_ATTEMPT_DATE, SLV_ACTUAL_LETHALITY, SLV_ACTUAL_POTENTIAL_LETHALITY } = clinRoService;
export default {
  components: {
    SinceLastVisitInto,
    Datepicker
  },
  props: {
    activityFormData: {},
    mode: {
      default: 0
    },
    queryIds: null,
    selectedId: null,
    lang: {
      type: String,
      default: "EN"
    }
  },
  methods: {
    clearAnswer(question) {
      if (question.answerId) {
        question.answerId = undefined;
      }
      if (question.answer) {
        question.answer = "";
      }
      if (question.date) {
        question.date = "";
      }
      this.onMostSevereIdeationChange(question);
    },
    onNumberValueChange(question, event) {
      event.target.value = event.target.value.replace(/[^0-9]+/g, "");
      const regExWholeNumber = "-?[0-9]+?";
      const regExpWholeNumber = new RegExp(`^${regExWholeNumber}$`);
      if (!regExpWholeNumber.test(Number(question.answer))) {
        question.answer = question.answer.replace(".", "");
        this.$toastr.error("Decimals are not allowed.");
      } else if (Number(question.answer) > 999 || question.answer.length > 3) {
        question.answer = question.answer.substring(0, 3);
        this.$toastr.error("Total must be an integer with max of 3 digits.");
      } else if (question.answer < 0) {
        question.answer = null;
        this.$toastr.error("Negative value not allowed.");
      }
      this.onAnswerChange(question);
    },
    OnBooleanValueChange(data, event) {
      if (event && event.target && !event.target.checked) {
        data.answerId = "";
        data.answer = "";
      } else {
        data.answerId = event.target.value;
      }
      this.onAnswerChange(data);
    },
    onFieldChange(componentData) {
      if (componentData && componentData.type == "DropDown" && componentData.answer == "") {
        componentData.answerId = "";
      }
      this.$nextTick(() => {
        for (let i = 0; i < componentData.options.length; i++) {
          const option = componentData.options[i];
          if (option.body == componentData.answer) {
            componentData.optionId = option.id;
            componentData.index = i;
          }
        }
        this.onAnswerChange(componentData);
      });
    },
    select(id) {
      if (this.queryIds && this.queryIds.includes(id) && this.hasQueryCreated(id) && this.hasQueryCreated(id).length) {
        this.$emit("selected", id);
      }
    },
    scrollToId() {
      if (this.selectedId) {
        window.document.getElementById(`${this.selectedId}`).scrollIntoViewIfNeeded(true);
      }
    },
    setErrorFieldsOnEachStep() {
      this.activityFormData.activity.questions.forEach(step => {
        this.$set(step, "hasFieldError", false);
        this.$set(step, "fieldErrorText", "");
      });
    },
    onCheckboxClick() {
      $("input:checkbox").on("click", function() {
        // in the handler, 'this' refers to the box clicked on
        const $box = $(this);
        if ($box.is(":checked")) {
          const group = "input:checkbox[name='" + $box.attr("name") + "']";
          $(group).prop("checked", false);
          $box.prop("checked", true);
        } else {
          $box.prop("checked", false);
        }
      });
    },
    onCheckBoxClick() {
      // step.answer = options.target.value;
      const $box = $(this);
      if ($box.is(":checked")) {
        // the name of the box is retrieved using the .attr() method
        // as it is assumed and expected to be immutable
        const group = "input:checkbox[name='" + $box.attr("name") + "']";
        // the checked state of the group/box on the other hand will change
        // and the current value is retrieved using .prop() method
        $(group).prop("checked", false);
        $box.prop("checked", true);
      } else {
        $box.prop("checked", false);
      }
    },
    onAnswerChange(step) {
      const selectedStepIndex = this.activityFormData.activity.questions.findIndex(o => o.id == step.id);
      this.activityFormData.activity.questions[selectedStepIndex] = step;

      const mostSevereIdeation = this.getMostSevereIdeation();
      const showValues = this.activityQuestions[8];
      if (showValues[0]) {
        showValues[0].answer = mostSevereIdeation.type;
        this.onMostSevereIdeationChange(showValues[0]);
      }
      if (showValues[1]) {
        showValues[1].answer = mostSevereIdeation.description;
        this.onMostSevereIdeationChange(showValues[1]);
      }
    },
    onMostSevereIdeationChange(step) {
      const selectedStepIndex = this.activityFormData.activity.questions.findIndex(o => o.id == step.id);
      this.activityFormData.activity.questions[selectedStepIndex] = step;
    },
    onSuicidalIdeationClearAnswer() {
      const noActivePlan = this.activityQuestions[SLV_ACTIVE_SUICIDAL_NO_PLAN];
      const specificPlan = this.activityQuestions[SLV_INTENT_TO_ACT];
      const planAndIntent = this.activityQuestions[SLV_ACTIVE_SUICIDAL_SPECIFIC_PLAN];
      this.clearAnswer(noActivePlan[0]);
      this.clearAnswer(noActivePlan[1]);
      this.clearAnswer(specificPlan[0]);
      this.clearAnswer(specificPlan[1]);
      this.clearAnswer(planAndIntent[0]);
      this.clearAnswer(planAndIntent[1]);
    },
    // INTENSITY OF IDEATION
    onIntensityOfIdeationClearAnswer() {
      this.clearAnswer(this.activityQuestions[7][0]);
      this.clearAnswer(this.activityQuestions[8][0]);
      this.clearAnswer(this.activityQuestions[9][0]);
      this.clearAnswer(this.activityQuestions[10][0]);
      this.clearAnswer(this.activityQuestions[11][0]);
    },
    onaActualAttemptClearAnswer() {
      const actualAttemptQuestion = this.activityQuestions[ACTUAL_ATTEMPT_SLV];
      this.clearAnswer(actualAttemptQuestion[1]);
      this.clearAnswer(actualAttemptQuestion[2]);

      this.clearAnswer(this.activityQuestions[SLV_ACTUAL_ATTEMPT_DATE][1]);
      this.clearAnswer(this.activityQuestions[SLV_ACTUAL_LETHALITY][0]);
      this.clearAnswer(this.activityQuestions[SLV_ACTUAL_POTENTIAL_LETHALITY][0]);
    },
    getMostSevereIdeation() {
      const { isWishToBeDead, isNonSpecific, isActivNoPlan, isSpecificPlan, isPlanAndIntent } = this;
      const mostSevereIdeation = {
        type: null,
        description: null
      };
      if (!isPlanAndIntent) {
        mostSevereIdeation.type = 5;
        mostSevereIdeation.description = "Active Suicidal Ideation with Specific Plan and Intent";
      } else if (!isSpecificPlan) {
        mostSevereIdeation.type = 4;
        mostSevereIdeation.description = "Active Suicidal Ideation with Some Intent to Act, without Specific Plan";
      } else if (!isActivNoPlan) {
        mostSevereIdeation.type = 3;
        mostSevereIdeation.description = "Active Suicidal Ideation with Any Methods (Not Plan) without Intent to Act";
      } else if (!isNonSpecific) {
        mostSevereIdeation.type = 2;
        mostSevereIdeation.description = "Non-Specific Active Suicidal Thoughts";
      } else if (!isWishToBeDead) {
        mostSevereIdeation.type = 1;
        mostSevereIdeation.description = "Wish to be Dead";
      }
      return mostSevereIdeation;
    },
    refresh() {}
  },
  data() {
    return {
      sinceLastVisit: sinceLastVisit,
      isFieldDisable: true,
      customActivityQuestion: [],
      activityQuestions: [],
      disabledFields: {},
      disabledDates: {
        from: new Date()
      },
      sinceLastVisitInstruction: "<p class='table-heading m-0'><span class='d-block'>Since Last</span> Visit</p>",
      suicidalBehaviorInstruction: "<p class='table-heading m-0'><span class='d-block'>Since</span> Last Visit</p>",
      mostSeverLabel: '<span class="d-block"> Most </span>Severe',
      enterCodeLabel: "<span>Enter Code</span>"
    };
  },
  watch: {
    selectedId: {
      handler() {
        this.scrollToId();
      }
    },
    activityFormData: function(newVal, oldVal) {
      // watch it
      this.activityQuestions = clinRoService.getActivityStructure(newVal, this.$route.params.studyId);
    }
  },
  mounted() {
    this.activityQuestions = clinRoService.getActivityStructure(this.activityFormData.activity, this.$route.params.studyId);
  },
  computed: {
    isWishToBeDead() {
      const wishToBeDeadQuestion = this.activityQuestions[WISH_TO_BE_DEAD_SINCE_LAST_VISIT];
      const wishToBeDead = !clinRoService.validateQuestionAnswer(wishToBeDeadQuestion[1]);
      return wishToBeDead;
    },

    isNonSpecific() {
      const nonSpecific = this.activityQuestions[NON_SPECIFIC_ACTIVE_SLV];
      const isNonSpecificQuestion = !clinRoService.validateQuestionAnswer(nonSpecific[1]);
      return isNonSpecificQuestion;
    },

    isActivNoPlan() {
      const noActivePlan = this.activityQuestions[SLV_ACTIVE_SUICIDAL_NO_PLAN];
      const activNoPlan = !clinRoService.validateQuestionAnswer(noActivePlan[1]);
      return activNoPlan;
    },

    isSpecificPlan() {
      const specificPlan = this.activityQuestions[SLV_INTENT_TO_ACT];
      const specificPlanQuestion = !clinRoService.validateQuestionAnswer(specificPlan[1]);
      return specificPlanQuestion;
    },

    isPlanAndIntent() {
      const planAndIntent = this.activityQuestions[SLV_ACTIVE_SUICIDAL_SPECIFIC_PLAN];
      const planAndIntentQuestion = !clinRoService.validateQuestionAnswer(planAndIntent[1]);
      return planAndIntentQuestion;
    },

    isInterruptedAttempt() {
      return false;
    },

    isAbortedAttempt() {
      return false;
    },

    isPreparatoryActs() {
      return false;
    },

    isSuicidalIdeation() {
      return false;
    },

    intensityOfIdeationSection() {
      return false;
    },

    isPotentialLethality() {
      return false;
    },

    issuicidalBehaviorSection() {
      return false;
    }
  }
};
</script>

<style scoped lang="scss">
.version-text {
  text-align: center;
  font-size: 15px;
  font-family: Times New Roman;
  color: #000000;
}
.alignleft {
  padding-left: 0 !important;
}
.text-col-8 {
  flex: 0 0 66.666667%;
  max-width: 66.666667%;
}
.boolean-question-text {
  position: absolute;
  left: -867px;
  white-space: nowrap;
  padding: 0px !important;
}
.txt-response-body {
  margin-top: 7rem;
}
.col.row {
  margin: 0 -15px !important;
}
.col-row {
  display: flex;
  flex: 0 0 100%;
  max-width: 100%;
}
.btnDisplay {
  top: 10px;
  right: 10px;
  position: absolute;
  border-color: #d3dfe4;
  background-color: #fff;
}
.btnDisplay:hover {
  color: #fff !important;
  background-color: #4c8ce4 !important;
}
.fieldCmp {
  color: #666669;
}
.form-components:last-of-type {
  padding-bottom: 15px;
}
.fieldCmp:hover + .btnDisplay,
.btnDisplay:hover {
  display: block;
}
.selected {
  background: #f9f9e0;
  border-color: #d3dfe4;
}
.custom-number-select-box {
  color: #000000;
  background-image: none;
  border: none;
  border-bottom: 1px solid #000;
  border-radius: 0px !important;
  background-color: initial;
  width: 52px !important;
  &:focus {
    border-radius: 0px !important;
    background-color: none;
    outline: 0;
    width: 52px !important;
    box-shadow: none !important;
  }
}
.custom-number-select-box:hover {
  cursor: pointer;
}
select.custom-number-select-box {
  text-align-last: center;
}
.col-size-3 {
  width: 10.999999996% !important;
  flex: 0 0 10.996% !important;
  max-width: 10.996% !important;
}
.col-size-7 {
  flex: 0 0 89.000000004%;
  max-width: 89.000000004%;
}
.span_box {
  width: 75px;
  display: block;
}
input.radio {
  width: 15px;
  height: 15px;
}

.select-size {
  width: 45% !important;
  &:focus {
    width: 45% !important;
  }
}
select.select-size {
  text-align-last: center;
}
.text-line-height {
  line-height: 1.1;
}
.most-severe-center {
  margin-top: -20px;
}

@media only screen and (min-width: 1280px) and (max-width: 1400px) {
  .col-size-3 {
    width: 12.999999996% !important;
    flex: 0 0 12.996% !important;
    max-width: 12.996% !important;
  }
  .col-size-7 {
    flex: 0 0 87.000000004%;
    max-width: 87.000000004%;
  }
}
</style>
